<template>
  <div class="login-page">
    <div class="form-container">
      <div class="logo">
        <img src="@/assets/img/logo.svg" alt="Venda e Ganhe Logo" />
      </div>
      <form @submit.prevent="onSubmit()">
        <div class="title">Acesso ao sistema</div>
        <app-input
          ref="loginInput"
          v-model="email"
          :control="$v.email"
          label="E-mail"
        ></app-input>
        <app-input v-model="password" label="Senha" type="password"></app-input>
        <a href>Esqueci minha senha</a>
        <button :disabled="$v.$invalid || isLoading" v-app-button type="submit">
          Entrar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ToastMixin from '@/mixins/ToastifyMixin';
import { AUTH_REQUEST } from '@/store/actions/auth';

import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'login-page',
  mixins: [ToastMixin],
  data: () => {
    return {
      email: null,
      password: null,
      isLoading: false,
    };
  },
  validations: {
    email: {
      email,
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    onSubmit() {
      if (this.$v.$invalid) return;

      const { email, password } = this;
      this.isLoading = true;

      this.$store
        .dispatch(AUTH_REQUEST, { email, password })
        .then(() => this.$router.push('/'))
        .catch(() => {
          this.isLoading = false;
          this.toastify('Dados inválidos. Tente novamente.', 'error');
        });
    },
  },
  mounted() {
    this.$refs.loginInput.focus();
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #f1f3f8;
}

.form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 24px;
  padding: 60px 90px;
  width: 630px;
  height: 600px;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);

  .logo {
    text-align: center;
    width: 230px;
    margin-bottom: 32px;
  }

  form {
    padding: 24px;
    border: 1px solid #eee;
    border-radius: 8px;
    min-width: 420px;

    .title {
      font-weight: bold;
      font-size: 1.4em;
      margin-bottom: 16px;
      text-align: center;
    }

    a {
      text-align: right;
      display: block;
      text-decoration: none;
      color: #777;
      font-size: 0.9em;
      margin-top: 16px;
      outline: 0;

      &:hover {
        text-decoration: underline;
      }
    }

    .app-button {
      margin-top: 16px;
      width: 100%;
    }
  }
}
</style>
